import * as mutation from "./mutation-types";
import * as action from "./action-types";
import { GLOBAL_ERROR } from "@/store/system/mutation-types";
import { deepCopyAxiosException } from "@/store/helpers";
import axios from "axios";

export const actions = {
  async [action.INVOICE_STATUS_GET]({ commit }, levyCollectionId) {
    commit(mutation.INVOICE_STATUS_GET_STARTED, levyCollectionId);
    try {
      const url = `/api/levy-collections/${levyCollectionId}/statistics/invoice-status`;
      const { data } = await axios.get(url);
      commit(mutation.INVOICE_STATUS_GET_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.INVOICE_STATUS_GET_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.INVOICE_STATUS_REFRESH]({ state, dispatch }, levyCollectionId) {
    const needsRefreshed =
      (!state.invoiceStatus.loaded && !state.invoiceStatus.loading) ||
      state.invoiceStatus.levyCollectionId != levyCollectionId;
    if (needsRefreshed) {
      dispatch(action.INVOICE_STATUS_GET, levyCollectionId);
    }
  },

  async [action.PAYMENT_STATUS_GET]({ commit }, levyCollectionId) {
    commit(mutation.PAYMENT_STATUS_GET_STARTED, levyCollectionId);
    try {
      const url = `/api/levy-collections/${levyCollectionId}/statistics/payment-status`;
      const { data } = await axios.get(url);
      commit(mutation.PAYMENT_STATUS_GET_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.PAYMENT_STATUS_GET_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.PAYMENT_STATUS_REFRESH]({ state, dispatch }, levyCollectionId) {
    const needsRefreshed =
      (!state.paymentStatus.loaded && !state.paymentStatus.loading) ||
      state.paymentStatus.levyCollectionId != levyCollectionId;
    if (needsRefreshed) {
      dispatch(action.PAYMENT_STATUS_GET, levyCollectionId);
    }
  },

  async [action.NOTICE_COUNTS_GET]({ commit }, levyCollectionId) {
    commit(mutation.NOTICE_COUNTS_GET_STARTED, levyCollectionId);
    try {
      const url = `/api/levy-collections/${levyCollectionId}/statistics/notice-counts`;
      const { data } = await axios.get(url);
      commit(mutation.NOTICE_COUNTS_GET_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.NOTICE_COUNTS_GET_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.NOTICE_COUNTS_REFRESH]({ state, dispatch }, levyCollectionId) {
    const needsRefreshed =
      (!state.noticeCounts.loaded && !state.noticeCounts.loading) ||
      state.noticeCounts.levyCollectionId != levyCollectionId;
    if (needsRefreshed) {
      dispatch(action.NOTICE_COUNTS_GET, levyCollectionId);
    }
  },

  async [action.ACTIVITY_FOR_WEEK_GET]({ commit }, levyCollectionId) {
    commit(mutation.ACTIVITY_FOR_WEEK_GET_STARTED, levyCollectionId);
    try {
      const url = `/api/levy-collections/${levyCollectionId}/statistics/activity-for-week`;
      const { data } = await axios.get(url);
      commit(mutation.ACTIVITY_FOR_WEEK_GET_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.ACTIVITY_FOR_WEEK_GET_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.ACTIVITY_FOR_WEEK_REFRESH]({ state, dispatch }, levyCollectionId) {
    const needsRefreshed =
      (!state.activityForWeek.loaded && !state.activityForWeek.loading) ||
      state.activityForWeek.levyCollectionId != levyCollectionId;
    if (needsRefreshed) {
      dispatch(action.ACTIVITY_FOR_WEEK_GET, levyCollectionId);
    }
  },

  async [action.ACTIVITY_FOR_YEAR_GET]({ commit }, levyCollectionId) {
    commit(mutation.ACTIVITY_FOR_YEAR_GET_STARTED, levyCollectionId);
    try {
      const url = `/api/levy-collections/${levyCollectionId}/statistics/activity-for-year`;
      const { data } = await axios.get(url);
      commit(mutation.ACTIVITY_FOR_YEAR_GET_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.ACTIVITY_FOR_YEAR_GET_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.ACTIVITY_FOR_YEAR_REFRESH]({ state, dispatch }, levyCollectionId) {
    const needsRefreshed =
      (!state.activityForYear.loaded && !state.activityForYear.loading) ||
      state.activityForYear.levyCollectionId != levyCollectionId;
    if (needsRefreshed) {
      dispatch(action.ACTIVITY_FOR_YEAR_GET, levyCollectionId);
    }
  },

  async [action.LEVY_COMPONENTS_GET]({ commit }, levyCollectionId) {
    commit(mutation.LEVY_COMPONENTS_GET_STARTED, levyCollectionId);
    try {
      const url = `/api/levy-collections/${levyCollectionId}/statistics/provider-component-amounts`;
      const { data } = await axios.get(url);
      commit(mutation.LEVY_COMPONENTS_GET_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.LEVY_COMPONENTS_GET_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.LEVY_COMPONENTS_REFRESH]({ state, dispatch }, levyCollectionId) {
    const needsRefreshed =
      (!state.levyComponents.loaded && !state.levyComponents.loading) ||
      state.levyComponents.levyCollectionId != levyCollectionId;
    if (needsRefreshed) {
      dispatch(action.LEVY_COMPONENTS_GET, levyCollectionId);
    }
  },

  async [action.PROVIDER_STATUS_GET]({ commit }, levyCollectionId) {
    commit(mutation.PROVIDER_STATUS_GET_STARTED, levyCollectionId);
    try {
      const url = `/api/levy-collections/${levyCollectionId}/statistics/provider-status`;
      const { data } = await axios.get(url);
      commit(mutation.PROVIDER_STATUS_GET_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.PROVIDER_STATUS_GET_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.PROVIDER_STATUS_REFRESH]({ state, dispatch }, levyCollectionId) {
    const needsRefreshed =
      (!state.providerStatus.loaded && !state.providerStatus.loading) ||
      state.providerStatus.levyCollectionId != levyCollectionId;
    if (needsRefreshed) {
      dispatch(action.PROVIDER_STATUS_GET, levyCollectionId);
    }
  },

  async [action.PROVIDER_LEVY_AMOUNTS_GET]({ commit }, levyCollectionId) {
    commit(mutation.PROVIDER_LEVY_AMOUNTS_GET_STARTED, levyCollectionId);
    try {
      const url = `/api/levy-collections/${levyCollectionId}/statistics/provider-total-levy-amounts`;
      const { data } = await axios.get(url);
      commit(mutation.PROVIDER_LEVY_AMOUNTS_GET_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.PROVIDER_LEVY_AMOUNTS_GET_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.PROVIDER_LEVY_AMOUNTS_REFRESH]({ state, dispatch }, levyCollectionId) {
    const needsRefreshed =
      (!state.providerLevyAmounts.loaded && !state.providerLevyAmounts.loading) ||
      state.providerLevyAmounts.levyCollectionId != levyCollectionId;
    if (needsRefreshed) {
      dispatch(action.PROVIDER_LEVY_AMOUNTS_GET, levyCollectionId);
    }
  }
};
